// extracted by mini-css-extract-plugin
export default {"candidateDashboardHeader":"candidate_candidateDashboardHeader__GuAmB","ratingDonut":"candidate_ratingDonut__4T7Fo","viewRatingLink":"candidate_viewRatingLink__Co6xp"};